import { stringify } from 'querystring';
import { network, generators } from '../../../utils';
import api from '../../../config/api';
import message from '../message';

const { generatorArray, generatorObject } = generators;

/** 丢弃过期的 queryCustom 响应，避免切换行时展示上一行数据 */
let customCodeRequestSeq = 0;

export const customCodePopState = {
  newCustomCode: null,
  newCustomCodeList: [],
  customCodeAddOrEdit: false,
  editingCustomCodeItem: null,
  customQueryImitm: null,
  customCodeListLoading: false,
};

const pickDefaultCustomCode = (list, preferUitemCode) => {
  if (
    preferUitemCode &&
    list.some((item) => item.uitemCode === preferUitemCode)
  ) {
    return preferUitemCode;
  }
  if (list.length > 0) {
    return list[0].uitemCode;
  }
  return null;
};

export const queryCustomEffect = async ({ payload: params, dispatch }) => {
  const seq = ++customCodeRequestSeq;
  const { imitm, preferUitemCode } = params;

  dispatch('updateState')({
    customCodeListLoading: true,
    customQueryImitm: imitm,
    newCustomCodeList: [],
  });

  const response = await network({
    url: api.sales.customCode,
    method: 'post',
    data: stringify({ imitm }),
  });

  if (seq !== customCodeRequestSeq) {
    return;
  }

  if (!response.success) {
    dispatch('updateState')({ customCodeListLoading: false });
    return;
  }

  if (!response.data.success) {
    message.error(response.data.message);
    dispatch('updateState')({ customCodeListLoading: false, newCustomCodeList: [] });
    return;
  }

  const list = generatorArray(response.data.data);
  dispatch('updateState')({
    newCustomCode: pickDefaultCustomCode(list, preferUitemCode),
    newCustomCodeList: list,
    customQueryImitm: imitm,
    customCodeListLoading: false,
  });
};

export const customCodePopEffects = {
  queryCustom: queryCustomEffect,
  deleteCustomCodeItem: async ({ payload }) => {
    const response = await network({
      url: api.customCode.deleteSingle,
      method: 'post',
      data: stringify(payload),
    });
    if (response.success) {
      const result = generatorObject(response.data);
      if (!result.success) {
        message.error(result.message);
        return false;
      }
      message.success('删除成功');
      return true;
    }
    return false;
  },
};
